import { DevicePolicyType } from "@/constants/devices";
import type { DeviceLabel } from "@/_store/devices-settings.module";
import type { DevicePolicyFileIntegrityItem } from "@/_store/device-policy/device-policy-settings.module";

export enum IntervalUnit {
  HOURS = "hours",
  DAYS = "days",
  WEEKS = "weeks",
}

export enum RepeatInterval {
  HOURLY = "hourly",
  DAILY = "daily",
  WEEKLY = "weekly",
}

export const INTERVAL_UNIT_TO_REPEAT_INTERVAL: Record<IntervalUnit, RepeatInterval> = {
  [IntervalUnit.HOURS]: RepeatInterval.HOURLY,
  [IntervalUnit.DAYS]: RepeatInterval.DAILY,
  [IntervalUnit.WEEKS]: RepeatInterval.WEEKLY,
};

export const REPEAT_INTERVAL_TO_INTERVAL_UNIT: Record<RepeatInterval, IntervalUnit> = {
  [RepeatInterval.HOURLY]: IntervalUnit.HOURS,
  [RepeatInterval.DAILY]: IntervalUnit.DAYS,
  [RepeatInterval.WEEKLY]: IntervalUnit.WEEKS,
};

export enum FileIntegrityAction {
  REVIEW = "review",
}

export type DevicePolicyFormModel = {
  id?: string;
  policyType?: DevicePolicyType;
  labels: DeviceLabel[];
} & Partial<Omit<DevicePolicyFileIntegrityItem, "policyType" | "labels">>;
